"use client";

import Link from "@/app/[lang]/_components/Link";
import { createT } from "@/app/[lang]/_utils/create-t";
import type { Lang } from "@/langs";
import { api } from "@/trpc/react";
import { authClient } from "@borderless/auth/client";
import { Button } from "@borderless/ui/components/button";
import { usePathname } from "next/navigation";
import { type FC } from "react";
import { BillingPortalButtonClient } from "../BillingPortalButtonClient";
import dictionary from "./t.json";

const t = createT(dictionary);

export const AuthInHeader: FC<{
  lang: Lang;
}> = (props) => {
  const { data: user } = api.user.findSelf.useQuery();
  const pathname = usePathname();

  if (user === undefined) {
    // loading
    return null;
  }
  if (user === null) {
    // logged out
    return (
      <div className="space-y-2">
        <div className="text-sm font-bold text-subtle">Account</div>
        <div>
          <Button variant="link" size="sm" asChild>
            <Link href={`/login?callbackUrl=${encodeURIComponent(pathname)}`}>
              {t("Log in", props.lang)}
            </Link>
          </Button>
          <Button variant="link" size="sm" asChild>
            <Link href={`/signup?callbackUrl=${encodeURIComponent(pathname)}`}>
              {t("Sign up", props.lang)}
            </Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="text-sm font-bold text-subtle">Account</div>
      <div>
        <Button variant="link" size="sm" asChild>
          <Link href="/me/profile">{t("My Profile", props.lang)}</Link>
        </Button>
        <BillingPortalButtonClient lang={props.lang} />
        <Button
          variant="link"
          size="sm"
          className="text-destructive"
          onClick={() => {
            void authClient.signOut().then(() => {
              window.location.reload();
            });
          }}
        >
          {t("Sign out", props.lang)}
        </Button>
      </div>
    </div>
  );
};
